import React, { useEffect, useRef, useState } from 'react';

import {
  SequenceImages,
  SequenceImageType,
} from '../../../constants/sequenceImages';

import styles from './SequenceImage.module.css';

interface SequenceImageProps {
  type: SequenceImageType;
}

export const SequenceImage: React.FC<SequenceImageProps> = ({ type }) => {
  const { imageStrip, totalFrames, interval, aspectRatio } =
    SequenceImages[type];
  const [currentFrame, setCurrentFrame] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [frameWidth, setFrameWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setFrameWidth(containerRef.current.offsetWidth);
      }
    };

    handleResize(); // Set initial width
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentFrame((prevFrame) => (prevFrame + 1) % totalFrames);
    }, interval);

    return () => clearInterval(intervalId);
  }, [interval, totalFrames]);

  return (
    <div
      ref={containerRef}
      className={styles.strip}
      style={{
        backgroundImage: `url(${imageStrip})`,
        backgroundPositionX: -currentFrame * frameWidth,
        width: '100%',
        height: `${frameWidth / aspectRatio}px`,
      }}
    />
  );
};
